import React, { Component } from "react";
import { auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import RemoveFromGroupButton from "./RemoveFromGroupButton";

class RemoveFromGroupLock extends Component {
  constructor(props) {
    super(props);

    this.removeLockFromGroup = this.removeLockFromGroup.bind(this);

    this.state = {
      selectedLock: [],
    };
  }

  removeLockFromGroup() {
    customLog(this.props.data);
    const data = this.props.data;
    const { dataCallBack } = this.props;

    const lockDetails = {
      lockId: data.lockId,
      Name: data.Name,
      Password: data.Password,
      Type: data.Type,
      ip45SerialNumber: data.ip45SerialNumber,
    };
    this.setState(
      {
        // selectedMembers: [...this.state.selectedMembers, memberDetails],
        lockDetails: [lockDetails],
      },
      () => {
        dataCallBack(this.state.lockDetails);
      }
    );
  }
  render() {
    // console.log(this.props);
    return (
      <div>
        <button
          className={"unselect-btn"}
          // disabled={
          //   this.props.data.isSuperAdmin ||
          // this.props.data.memberEmail === auth.currentUser.email
          // }
          onClick={this.removeLockFromGroup}
        >
          &times;
        </button>
      </div>
    );
  }
}

export default RemoveFromGroupLock;
